import React, {Suspense} from "react";
import {Routes as ReactDomRouter, Route} from "react-router-dom";
import PrivateRoute from "./PrivateRoute";

const Movies = React.lazy(() => import("../../Movie/Movies"));
const HomePage = React.lazy(() => import("../../HomePage/HomePage"));
const Dashboard = React.lazy(() => import("../../Post/Posts"));
//const AddEditPost = React.lazy(() => import("../../Post/AddEditPost"));
const PostById = React.lazy(() => import("../../Post/PostById"));


const Routes = (): JSX.Element => (
    <Suspense fallback={<div>Loading...</div>}>
        <ReactDomRouter>
            <Route path="/movies" element={<PrivateRoute component={Movies}/>}/>
            <Route path="/" element={<HomePage/>}/>
            <Route path="/posts" element={<PrivateRoute component={Dashboard}/>}/>
            {/*<Route path="/post/new" element={<PrivateRoute component={AddEditPost}/>}/>*/}
            <Route path="/post/:id" element={<PrivateRoute component={PostById}/>}/>
            {/*<Route path="/post/:id/edit" element={<PrivateRoute component={AddEditPost}/>}/>*/}
            <Route path="*" element={<div>Not Found</div>}/>
        </ReactDomRouter>
    </Suspense>
);

export default Routes;